import React from "react";

import MarkdownPage from "../components/MarkdownPage";

const AboutUs = () => {
  return (
    <MarkdownPage url="https://raw.githubusercontent.com/REmatchChile/REmatch-docs/main/tutorial.md" />
  );
};

export default AboutUs;
